import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'
import { DURATIONS, EASING, RADII } from 'styles/consts'
import {
  boxShadowStyles,
  customizeVerticalScrollbarThumbMixin
} from 'styles/mixins'

// Caps the picker at ~5 rows; longer lists scroll inside.
export const OptionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 260px;
  overflow-y: auto;
  padding: 8px;
  /* Menu-surface tokens, matching the other floating menus (export options,
     model submenu) rather than the pre-refresh 8px/white pair. */
  border-radius: ${RADII.card};
  background: ${COLORS.surface};

  ${boxShadowStyles('shadow2')}
  ${customizeVerticalScrollbarThumbMixin()}
`

export const Option = styled.div<{ $isHighlighted?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: ${COLORS.textPrimary};
  border-radius: ${RADII.item};
  transition: background-color ${DURATIONS.fast} ${EASING.out};

  ${({ $isHighlighted }) =>
    $isHighlighted &&
    css`
      background-color: ${COLORS.primaryLight};
    `}

  span {
    white-space: nowrap;
  }
`

export const Thumbnail = styled.img`
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: ${RADII.item};
  flex-shrink: 0;
`
